import makeStyles from "@mui/styles/makeStyles";

const styles = makeStyles((theme) => ({
  info: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "24px",
    color: "#667085",
    marginLeft: "10px",
  },
  icon: {
    fontSize: "18px",
  },
  iconButton: {
    padding: "5px",
  },
  itemCenter: {
    display: "flex",
    alignItems: "center",
  },
  contacts: {
    backgroundColor: "#F9FAFB",
    border: "1px solid #E4E7EC",
    borderRadius: "8px",
    width: "100%",
    padding: "16px",
    boxSizing: "border-box",
  },
  paper: {
    top: "50%",
    left: "50%",
    transform: `translate(-50%, -50%)`,
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "8px",
    width: "90vw",
    maxHeight: "80vh",
    overflowY: "auto",
    overflowX: "hidden",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    [theme.breakpoints.down("md")]: {
      width: "55vw",
    },
    [theme.breakpoints.down("sm")]: {
      width: "85vw",
    },
  },
  modalBody: {
    height: "100%",
    width: "100%",
  },
  titleName: {
    fontFamily: "Manrope",
    fontSize: "20px",
    fontWeight: 700,
    color: "#344054",
    lineHeight: "28px",
  },
  locationModalTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  content: {
    padding: "20px",
  },
}));

export default styles;
